import { HeaderStyled } from './styled';

import clsx from 'clsx';

interface HeaderProps {
  className?: string;
}

const Header = ({ className }: HeaderProps) => {
  return (
    <HeaderStyled className={clsx('Header', className)}>
      <div className="title">운동 결과</div>
    </HeaderStyled>
  );
};

export default Header;
